import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Auth } from '../../auth/auth.service';
import { MessengerService } from '../../messenger/messenger.service';
import { BreadcrumbsService } from '../../shared/components/breadcrumbs/breadcrumbs.service';
import { Sermon } from '../classes/sermon';
var SermonsComponent = /** @class */ (function () {
    function SermonsComponent(auth, _breadcrumbs, _messenger) {
        this.auth = auth;
        this._breadcrumbs = _breadcrumbs;
        this._messenger = _messenger;
        this.pending = false;
        this.subscriptions = [];
    }
    Object.defineProperty(SermonsComponent.prototype, "sermons", {
        get: function () {
            return this.pagination && this.pagination.data;
        },
        enumerable: true,
        configurable: true
    });
    SermonsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (s) { return s && s.unsubscribe(); });
    };
    SermonsComponent.prototype.ngOnInit = function () {
        this._breadcrumbs.start({ name: 'Felvételek', instructions: ['/felvetelek'] }).add({ name: 'Tanítások' });
        this.loadPage();
        // this.subscriptions.push(this.handleObservable(new Sermon().all()));
    };
    SermonsComponent.prototype.loadPage = function (url) {
        this.pending = true;
        this.subscriptions.push(this.handleObservable(new Sermon().page(url)));
    };
    SermonsComponent.prototype.removeSermon = function (sermon) {
        var _this = this;
        if (confirm("Biztosan t\u00F6r\u00F6lni szeretn\u00E9d? " + sermon.date + ", " + sermon.preacher + ", " + sermon.title)) {
            this.subscriptions.push(sermon.remove().subscribe(function () { return _this.pagination.data = _this.pagination.data.filter(function (s) { return s.id !== sermon.id; }); }));
        }
    };
    SermonsComponent.prototype.handleObservable = function (obs) {
        var _this = this;
        return obs.map(function (pagination) {
            _this.pending = false;
            return pagination;
        })
            .catch(function (e) {
            _this.pending = false;
            throw e;
        })
            .subscribe(function (pagination) { return _this.pagination = pagination; }, this._messenger.handleError);
    };
    return SermonsComponent;
}());
export { SermonsComponent };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/sermons/sermons.component.ts.pre-build-optimizer.js